import { isUnifiedDuffelOffer } from "./unifiedFlightBookingGuard";
import { deriveBookingMode, getPaymentRequirements } from "./paymentRequirements";

/**
 * Hold-capable Duffel offer after resolve — trusted server fields only.
 * @param {unknown} offer
 */
export function isHoldEligibleDuffelOffer(offer) {
  if (!isUnifiedDuffelOffer(offer)) return false;
  if (offer.duffelResolved !== true) return false;
  const pr = getPaymentRequirements(offer);
  if (!pr || typeof pr.requiresInstantPayment !== "boolean") return false;
  return deriveBookingMode(pr) === "hold-eligible";
}

/** Instant Duffel — keep existing payment / draft path, not hold confirmation. */
export function isInstantDuffelOffer(offer) {
  if (!isUnifiedDuffelOffer(offer)) return false;
  const pr = getPaymentRequirements(offer);
  if (!pr || typeof pr.requiresInstantPayment !== "boolean") return false;
  return pr.requiresInstantPayment === true;
}
